import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document",
  style: {"max-width":"650px"}
}
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "position-absolute top-0 end-0 mt-2 me-2 z-index-1" }
const _hoisted_5 = { class: "modal-body p-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-top-lg py-3 ps-4 pe-6 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "mb-1",
    style: {"color":"#004761"}
  }, " Assign exercises to Classgroup ")
], -1)
const _hoisted_7 = { class: "p-4 pt-2 pb-0" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "classgroups" }, "Classgroups", -1)
const _hoisted_10 = {
  class: "form-select js-choice",
  id: "classgroups",
  ref: "selectClassgroups",
  multiple: "multiple",
  size: "1",
  name: "classgroups",
  "data-options": "{\"removeItemButton\":true,\"placeholder\":true}"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select classgroup...", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "classgroups" }, "Available in App", -1)
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "classgroups" }, "Completion Deadline", -1)
const _hoisted_17 = { class: "modal-footer align-items-center px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-close btn btn-sm btn-circle d-flex flex-center transition-base",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("select", _hoisted_10, _hoisted_12, 512)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control datetimepicker",
                  type: "text",
                  placeholder: "yyyy/mm/dd",
                  "aria-invalid": "false",
                  "data-options": "{'disableMobile':true}",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.availableFrom) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.availableFrom]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control datetimepicker",
                  type: "text",
                  placeholder: "yyyy/mm/dd",
                  "aria-invalid": "false",
                  "data-options": "{'disableMobile':true}",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deadline) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.deadline]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-primary d-block w-100",
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.assign && _ctx.assign(...args)))
          }, " Assign exercises to the selected classgroups ")
        ])
      ])
    ])
  ]))
}